import {
  ATUALIZAR_USUARIO,
  LIMPAR_USUARIO,
} from "./actions";

const initialState = {
  usuarioLogado: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ATUALIZAR_USUARIO:
      return { ...state, usuarioLogado: { ...action.usuarioLogado } };
    case LIMPAR_USUARIO:
      return { ...state, usuarioLogado: {} };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/componentes/usuario/reducers.js